import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  flex: 1;
  width: 100%;
  height: calc(100% * (var(--total-table-rows, 6) / 6));
  max-height: calc(100% * (var(--total-table-rows, 6) / 6));

  padding: 0;

  .MuiTableCell-root {
    font-size: 1rem;
    text-align: center;
    padding: 0;
    vertical-align: middle;
  }

  .MuiTableHead-root {
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    padding: 0;
    vertical-align: middle;
    background-color: #eee;
    height: calc(100% / var(--total-table-rows, 6));
    max-height: calc(100% / var(--total-table-rows, 6));
  }

  .MuiTableContainer-root {
    height: 100%;
    overflow: hidden;
  }

  .MuiTable-root {
    height: 100%;
    width: 100%;
    table-layout: fixed;
  }

  .MuiTableRow-root {
    height: calc(100% / var(--total-table-rows, 6));
    max-height: calc(100% / var(--total-table-rows, 6));
    box-sizing: border-box;
  }
`;
